'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './property-list.routes';

const moment = require('moment');

export class PropertyListComponent {
  constructor(Auth, PropertyService, dialogs, $scope, DTOptionsBuilder, DTDefaultOptions,
              DTState, SettingsService, DTColumnBuilder, $timeout) {
    'ngInject';

    console.time();

    this.$scope = $scope;
    this.$timeout = $timeout;

    this.valueMap = {
      address: {},
      hasPrimaryOwner: {},
      hasPrimaryOwnerRemoved: {},
      primaryOwnerHtml: {},
      primaryOwnerId: {},
      hasOtherOwner: {},
      hasOtherOwnerRemoved: {},
      otherOwnerHtml: {},
      otherOwnerId: {},
      buildingUnit: {}
    };

    this.PropertyService = PropertyService;
    this.filteredData = [];
    this.data = [];
    this.selectedCommunityCode = "";

    this.dialogs = dialogs;

    DTDefaultOptions.setLoadingTemplate( '<datatable-loading-placeholder columns="Cmty, Lot#, Address, Primary Owner, Other Owner, Active Tenant" />');

    SettingsService.getByName({name: 'config.app'}, settings => {
      let ssDT = settings.data.serverSideDT || {};
      this.serverSideDT = ssDT && ssDT.properties && ssDT.properties.enabled;
      this.serverSideUseBldgUnit = ssDT && ssDT.properties && ssDT.properties.useBldgUnit;

      SettingsService.getByName({name: 'client'}, settings => {
        this.hasBuildingNo = settings.data.buildingNoVisible;

        let that = this;

        if (this.serverSideDT) {

          this.dtColumns = [];

          if (this.serverSideUseBldgUnit)
            this.dtColumns.push(DTColumnBuilder.newColumn("customFields.buildingUnit").withTitle('Bldg-Unit').withOption('width', '3%'));
          else if (this.hasBuildingNo) {
            this.dtColumns.push(DTColumnBuilder.newColumn("buildingNo").withTitle('Bldg#').withOption('width', '3%'));
            this.dtColumns.push(DTColumnBuilder.newColumn("lotNo").withTitle('Lot#').withOption('width', '3%'));
          } else {
            this.dtColumns.push(DTColumnBuilder.newColumn("lotNo").withTitle('Lot#').withOption('width', '3%'));
          }

          this.dtColumns.push(DTColumnBuilder.newColumn("address").withTitle('Address').withOption('width', '40%'));
          //this.dtColumns.push(DTColumnBuilder.newColumn("primaryOwner").withTitle('Primary Owner').withOption('width', '15%'));
          //this.dtColumns.push(DTColumnBuilder.newColumn("otherOwner").withTitle('Other Owner').withOption('width', '15%'));

          this.defaultOrder = (this.hasBuildingNo) ? [[0, 'asc'], [1, 'asc']] : [0, 'asc'];
          if (this.serverSideUseBldgUnit)
            this.defaultOrder = [0, 'asc'];

          this.dtOptionsSS = DTOptionsBuilder.newOptions()
            //.withOption('dom', 'lBfrtip')
            .withOption('serverSide', true)
            //.withOption('processing', true)
            //.withDataProp('data')
            .withOption('stateSave', true)
            .withOption('stateSaveCallback', DTState.save())
            .withOption('stateLoadCallback', DTState.restore())
            .withOption('pagingType', 'full_numbers')
            .withOption('order', this.defaultOrder)
            .withOption('pageLength', 10)
            .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
            //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
            .withOption('ajax', (params, cb) => {

              console.log("enter", params);

              if (params.search) {
                if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
                  return;

                params.search.fields = ["buildingNo", "lotNo", "address.street", "customFields.buildingUnit", "contacts[].contact.company", "contacts[].contact.lastName, contacts[].contact.firstName", "contacts[].contact.firstName", "contacts[].contact.lastName"];
              }

              that.PropertyService.queryDT(params, result => {

                if (params.search && params.search.value) {
                  let searchTerms = params.search.value.split(",").map(t => t.trim());
                  that.buildValueMap(result.data, true, searchTerms);
                } else {
                  that.buildValueMap(result.data);
                }

                that.data = result.data;
                this.filterData();

                cb({
                  recordsTotal: result.recordsTotal,
                  recordsFiltered: result.recordsFiltered,
                  data: []
                });

                that.$timeout(_=>{
                  $('#dtProperties').DataTable().columns.adjust();
                }, 0);
              })
            });
          this.ssInitReady = true;
        } else {

          this.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('dom', 'lBfrtip')
            .withOption('order', (this.hasBuildingNo) ? [[0, 'asc'], [1, 'asc']] : [0, 'asc'])
            .withOption('deferRender', true)
            .withOption('initComplete', _ => {
              this.initComplete = true;
              console.timeEnd()
            })
            .withOption('stateSave', true)
            .withOption('stateSaveCallback', DTState.save())
            .withOption('stateLoadCallback', DTState.restore())
            .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
            .withOption('buttons', [{
              extend: 'excel',
              title: "Properties"
            }, {
              extend: 'csv',
              title: "Properties"
            }, {
              title: "Properties",
              message: 'As of ' + moment().format("MMMM Do YYYY"),
              extend: 'pdf',
              orientation: 'portrait',
              pageSize: 'LETTER'
            }, {
              extend: 'print',
              title: "Properties"
            }]);


          this.PropertyService.query((data) => {
            this.data = data;

            console.timeLog();

            this.buildValueMap(data);

            this.filterData();
            this.dataInitComplete = true;
            console.timeLog();
          }, err => {
            console.log("Could not retrieve properties.")
          });

        }
      });
    });
  }


  buildValueMap(data, highlight, searchTerms) {
    data.forEach(ppty => {
      this.valueMap.address[ppty._id] = this.getAddress(ppty);
      this.valueMap.hasPrimaryOwnerRemoved[ppty._id] = this.getPrimaryOwnerId(ppty.contacts) === -1;
      this.valueMap.hasPrimaryOwner[ppty._id] = this.getPrimaryOwnerId(ppty.contacts) !== 0 && !this.valueMap.hasPrimaryOwnerRemoved[ppty._id];

      if (this.valueMap.hasPrimaryOwner[ppty._id]) {
        this.valueMap.primaryOwnerId[ppty._id] = this.getPrimaryOwnerId(ppty.contacts);
        this.valueMap.primaryOwnerHtml[ppty._id] = this.getPrimaryOwner(ppty.contacts);
      }

      this.valueMap.hasOtherOwnerRemoved[ppty._id] = this.getOtherOwnerId(ppty.contacts) === -1;
      this.valueMap.hasOtherOwner[ppty._id] = this.getOtherOwnerId(ppty.contacts) !== 0 && !this.valueMap.hasOtherOwnerRemoved[ppty._id];

      if (this.valueMap.hasOtherOwner[ppty._id]) {
        this.valueMap.otherOwnerId[ppty._id] = this.getOtherOwnerId(ppty.contacts);
        this.valueMap.otherOwnerHtml[ppty._id] = this.getOtherOwner(ppty.contacts);
      }

      if (ppty.customFields && ppty.customFields.buildingUnit)
        this.valueMap.buildingUnit[ppty._id] = ppty.customFields.buildingUnit;

      if (highlight && searchTerms && searchTerms.length) {
        searchTerms.sort(function(a, b) {
          return b.length - a.length;
        });

        var regexFirst = new RegExp(searchTerms[0], 'i');
        var regexAll = new RegExp('(' + searchTerms.join('|') + ')', 'gi');

        if (this.valueMap.primaryOwnerHtml[ppty._id])
          this.valueMap.primaryOwnerHtml[ppty._id] = this.valueMap.primaryOwnerHtml[ppty._id].replace(regexAll, '<b>$&</b>');

        if (this.valueMap.otherOwnerHtml[ppty._id])
          this.valueMap.otherOwnerHtml[ppty._id] = this.valueMap.otherOwnerHtml[ppty._id].replace(regexAll, '<b>$&</b>');

        this.valueMap.address[ppty._id] = this.valueMap.address[ppty._id].replace(regexFirst, '<b>$&</b>');

        if (this.valueMap.buildingUnit[ppty._id])
          this.valueMap.buildingUnit[ppty._id] = this.valueMap.buildingUnit[ppty._id].replace(regexFirst, '<b>$&</b>');
      }
    });
  }

  filterData() {
      this.filteredData = this.data;
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "") {
        composedName += contact.company;
      } else {
        composedName += "<br/>" + contact.company;
      }
    }

    return composedName;
  }

  getAddress(property) {
    try {
      let address = property.address.street;

      if (property.address.city && property.address.state && property.address.zip) {
        address += `, ${property.address.city} ${property.address.state}, ${property.address.zip}`;
      } else if (property.address.city) {
        address += `, ${property.address.city}`;
      } else if (property.address.state && property.address.zip) {
        address += `, ${property.address.state}, ${property.address.zip}`;
      }

      return address;
    } catch (e){
      return "-";
    }
  }

  delete(property) {
    var that = this;

    let address = "";
    try {
      address = this.getAddress(property);
    } catch (e){}

    var propertyText = "<br/><br/><b> Unit/Lot# " + property.lotNo + "</b><br/><p>" + address + "</p>";

    var dlg = this.dialogs.confirm("Delete Property?", "Do you really want to delete this property?" + propertyText);
    dlg.result.then(() => {
      // OK delete it
      that.PropertyService.delete({id: property._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== property._id;
          });

          that.filterData(that.selectedCommunityCode);
        },
        err => {
          alert("Could not delete property");
        });
    }, () => {
      // Cancel
    });
  }

  getPrimaryOwnerId(contacts) {
    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary) // No Primary Owner
      return 0;
    else if (!primary.contact || !primary.contact._id) // Contact for Primary Owner deleted
      return -1;
    else
      return primary.contact._id;
  }

  getOtherOwnerId(contacts) {
    let other = contacts.find(contact => contact.type == 'owner');

    if (!other) // No Other Owner
      return 0;
    else if (!other.contact || !other.contact._id) // Contact for Other Owner deleted
      return -1;
    else
      return other.contact._id;
  }

  getActiveTenantId(contacts) {
    let activeTenant = contacts.find(contact => {
      try {
        if (contact.type == 'renter') {

          if (!contact.from && !contact.till) // if no dates are defined, we assume thatt the renter should be the current one
            return true;

          if (contact.from && contact.till) {
            return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
          }

          if (!contact.from && contact.till) {
            return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
          }

          if (contact.from && !contact.till) {
            return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
          }
        } else {
          return false;
        }

      } catch(e) {
        console.log(e);
        return false;
      }
    });

    if (!activeTenant) // No Other Owner
      return 0;
    else if (!activeTenant.contact || !activeTenant.contact._id) // Contact for Other Owner deleted
      return -1;
    else
      return activeTenant.contact._id;
  }

  getPrimaryOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary)
      return "-";

    return this.getComposedName(primary.contact);
  }

  getOtherOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let other = contacts.find(contact => contact.type == 'owner');

    if (!other)
      return "-";

    return this.getComposedName(other.contact);
  }

  getActiveTenant(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let activeTenant = contacts.find(contact => {
      try {
        if (contact.type == 'renter') {

          if (!contact.from && !contact.till) // if no dates are defined, we assume thatt the renter should be the current one
            return true;

          if (contact.from && contact.till) {
            return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
          }

          if (!contact.from && contact.till) {
            return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
          }

          if (contact.from && !contact.till) {
            return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
          }
        } else {
          return false;
        }

      } catch(e) {
        console.log(e);
        return false;
      }
    });

    if (!activeTenant)
      return "-";

    return this.getComposedName(activeTenant.contact);
  }

}

export default angular.module('conduu.propertyList', [uiRouter])
  .config(routes)
  .component('propertyList', {
    template: require('./property-list.html'),
    controller: PropertyListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/property-list/property-list.component.js